import React, { useState } from "react";
import "../../assets/scss/pages/admin/_journeyAIAdmin.scss";

const JourneyAIAdmin: React.FC = () => {
	const [selectedScenario, setSelectedScenario] = useState(0);

	const scenarios = [
		{
			title: "Brazilian CPG Brand Launches New Juice SKU",
			description:
				"A major CPG brand in Brazil is launching a new açaí-based juice, causing a spike in demand for açaí pulp and specific packaging materials. This simulation models the supply chain impact.",
			dataVisual: "Supply Chain Demand Spike Chart",
			implications:
				"Potential for supplier shortages and price increases for competitors. Opportunity to offer alternative ingredient sourcing or pre-book packaging capacity for our clients.",
			summary:
				"A major CPG brand in Brazil is launching a new açaí-based juice, causing a spike in demand for açaí pulp and specific packaging materials. This simulation models the supply chain impact.",
			dataSources: ["ANVISA (Brazil)", "Nielsen Market Data", "Internal Supplier Pricing"],
			metrics: [
				{ label: "Açaí Pulp Price", value: "+15% projected" },
				{ label: "Packaging Lead Time", value: "+3 weeks" },
				{ label: "Market Share Opportunity", value: "2.5% for agile competitors" }
			],
			actions: [
				"Alert clients using açaí about potential price hikes.",
				"Identify alternative berry suppliers in the region.",
				"Model margin impact for clients' existing product lines."
			]
		},
		{
			title: "USDA Reports Poor Soybean Harvest",
			description:
				"Unexpected weather patterns have led to the USDA downgrading the soybean harvest forecast by 12%. This simulation explores the ripple effects on soy-based products and animal feed.",
			dataVisual: "Soy Supply Impact Graph",
			implications:
				"Increased costs for clients producing tofu, soy milk, and other derivatives. This is a key opportunity for clients to diversify sourcing.",
			summary:
				"Unexpected weather patterns have led to the USDA downgrading the soybean harvest forecast by 12%. This simulation explores the ripple effects on soy-based products and animal feed.",
			dataSources: ["USDA Forecast", "Commodity Exchange Data", "Regional Weather Reports"],
			metrics: [
				{ label: "Soybean Yield", value: "-12% projected" },
				{ label: "Soymeal Prices", value: "+20%" },
				{ label: "Livestock Feed Cost", value: "+8%" }
			],
			actions: [
				"Advise clients to diversify protein sources.",
				"Recommend locking in soymeal contracts early.",
				"Model downstream impacts on dairy alternatives."
			]
		}
	];

	return (
		<div className="scenario-engine">
			{/* Header */}
			<div className="scenario-header">
				<div className="header-content">
					<input type="text" placeholder="Search scenarios..." className="search-input" />
					<button className="simulate-btn">Simulate My Customer</button>
					<div className="notification-bell">🔔</div>
				</div>
			</div>

			<div className="scenario-intro">
				<h3 className="scenario-title">Scenario Engine</h3>
				<p className="scenario-subtitle">
					Weekly simulations based on real-world market, client, and data patterns.
				</p>
			</div>

			<div className="scenario-layout">
				{/* Left Column */}
				<div className="scenario-list">
					{scenarios.map((s, idx) => (
						<div
							className={`scenario-card ${selectedScenario === idx ? 'active' : ''}`}
							key={idx}
							onClick={() => setSelectedScenario(idx)}
						>
							<div className="scenario-card-header">
								<h4 className="scenario-card-title">✨ {s.title}</h4>
								<p className="scenario-description">{s.description}</p>
							</div>

							<div className="scenario-body">
								<div className="scenario-section">
									<h6>Data Visual</h6>
									<div className="scenario-placeholder">{s.dataVisual}</div>
								</div>
								<div className="scenario-section">
									<h6>Implications for Journey Foods</h6>
									<p>{s.implications}</p>
								</div>
							</div>

							<div className="scenario-actions">
								<button className="action-btn">📄 Generate Case Study</button>
								<button className="action-btn">📈 Use in Sales Call</button>
								<button className="action-btn">💡 Suggest a Feature</button>
							</div>
						</div>
					))}
				</div>

				{/* Right Column */}
				<div className="scenario-detail">
					<div className="detail-header">
						<h4>{scenarios[selectedScenario].title}</h4>
					</div>

					<div className="detail-content">
						<div className="detail-section">
							<h6>Summary</h6>
							<p>{scenarios[selectedScenario].summary}</p>
						</div>

						<div className="detail-section">
							<h6>Data Sources Used</h6>
							<ul>
								{scenarios[selectedScenario].dataSources.map((src, i) => (
									<li key={i}>{src}</li>
								))}
							</ul>
						</div>

						<div className="detail-section">
							<h6>Key Metrics</h6>
							<ul>
								{scenarios[selectedScenario].metrics.map((m, i) => (
									<li key={i}>
										<strong>{m.label}: </strong>
										{m.value}
									</li>
								))}
							</ul>
						</div>

						<div className="detail-section">
							<h6>Suggested Actions</h6>
							<ul>
								{scenarios[selectedScenario].actions.map((a, i) => (
									<li key={i}>{a}</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default JourneyAIAdmin;
